import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ml-panel-header" }
const _hoisted_2 = { class: "row items-center no-wrap q-gutter-x-sm" }
const _hoisted_3 = { class: "col row items-center no-wrap q-gutter-x-sm q-mx-sm" }
const _hoisted_4 = {
  class: "text-caption text-white",
  style: {"opacity":"0.8","white-space":"nowrap"}
}
const _hoisted_5 = { class: "ml-panel-body" }
const _hoisted_6 = {
  key: 0,
  class: "column items-center justify-center q-pa-lg"
}
const _hoisted_7 = {
  key: 1,
  class: "column items-center justify-center q-pa-lg text-center"
}
const _hoisted_8 = {
  key: 2,
  class: "column items-center justify-center q-pa-lg text-center"
}
const _hoisted_9 = { class: "text-body2 q-mt-sm text-grey-7" }
const _hoisted_10 = { class: "row items-center no-wrap q-px-xs q-pt-xs" }
const _hoisted_11 = { class: "col text-center" }
const _hoisted_12 = { class: "row items-center justify-center no-wrap q-gutter-x-xs" }
const _hoisted_13 = {
  class: "text-caption text-grey-5",
  style: {"font-size":"10px"}
}
const _hoisted_14 = { class: "row items-center q-px-sm q-pb-xs q-gutter-x-sm" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "text-caption text-bold" }
const _hoisted_17 = { class: "col-auto" }
const _hoisted_18 = { class: "text-caption text-bold" }
const _hoisted_19 = { class: "col-auto column items-end" }
const _hoisted_20 = { class: "q-px-sm q-pb-xs" }
const _hoisted_21 = {
  key: 0,
  class: "row justify-center q-pa-sm"
}
const _hoisted_22 = {
  key: 1,
  class: "text-caption text-grey-5 q-py-xs text-center"
}
const _hoisted_23 = {
  key: 0,
  class: "text-caption text-grey-6 q-pb-xs text-center"
}
const _hoisted_24 = { class: "row q-gutter-md justify-center ml-waveform-row" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "text-caption text-center text-bold q-mb-xs" }
const _hoisted_27 = { class: "row q-px-sm q-pb-xs q-gutter-x-sm" }
const _hoisted_28 = { class: "row q-px-sm q-pb-sm q-gutter-x-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_slider = _resolveComponent("q-slider")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_spinner_dots = _resolveComponent("q-spinner-dots")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_PipelineSectionMarkerPassagesDialog = _resolveComponent("PipelineSectionMarkerPassagesDialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["ml-passages-panel", { 'ml-panel--new-detection': _ctx.newDetection }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_q_icon, {
              name: "psychology",
              color: "white",
              size: "18px"
            }),
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-subtitle2 text-white text-bold" }, "ML Verified Passages", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, " >" + _toDisplayString(_ctx.mlDisplayThreshold) + "% ", 1),
              _createVNode(_component_q_slider, {
                modelValue: _ctx.mlDisplayThreshold,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mlDisplayThreshold) = $event)),
                min: 50,
                max: 99,
                step: 1,
                color: "white",
                "track-color": "blue-grey-5",
                class: "col",
                dense: "",
                onChange: _ctx.onThresholdChange
              }, null, 8, ["modelValue", "onChange"])
            ]),
            (_ctx.currentPassage)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  flat: "",
                  dense: "",
                  round: "",
                  icon: "place",
                  color: "white",
                  size: "sm",
                  title: "Zoom to Pig",
                  onClick: _ctx.onZoomToPig
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_q_btn, {
              flat: "",
              dense: "",
              round: "",
              icon: "refresh",
              color: "white",
              size: "sm",
              loading: _ctx.loading,
              title: "Reload",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadMLPassages(false)))
            }, null, 8, ["loading"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.loading && _ctx.enrichedPassages.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_q_spinner_dots, {
                  color: "primary",
                  size: "40px"
                }),
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-caption q-mt-sm text-grey-7" }, "Fetching passages…", -1))
              ]))
            : (!_ctx.selectedPigRunEntry)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_q_icon, {
                    name: "route",
                    color: "grey-5",
                    size: "40px"
                  }),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-body2 q-mt-sm text-grey-7" }, " No pig run is currently selected. ", -1)),
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-caption text-grey-5 q-mt-xs" }, " Select a pig run using the map layer control above. ", -1))
                ]))
              : (!_ctx.loading && _ctx.enrichedPassages.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_q_icon, {
                      name: "search_off",
                      color: "grey-5",
                      size: "40px"
                    }),
                    _createElementVNode("div", _hoisted_9, " No ML passages above " + _toDisplayString(_ctx.mlDisplayThreshold) + "% found. ", 1),
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-caption text-grey-5 q-mt-xs" }, " High-confidence passaged will appear here when detected. ", -1))
                  ]))
                : (_ctx.currentPassage)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      (_ctx.loading)
                        ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                            key: 0,
                            indeterminate: "",
                            color: "primary",
                            size: "2px"
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_q_btn, {
                          flat: "",
                          dense: "",
                          round: "",
                          icon: "chevron_left",
                          color: "primary",
                          size: "sm",
                          disable: _ctx.prevMarkerFirstIndex === -1,
                          onClick: _ctx.onPrevPassage
                        }, null, 8, ["disable", "onClick"]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-caption text-grey-5" }, "Pig Run", -1)),
                            _createVNode(_component_q_btn, {
                              flat: "",
                              dense: "",
                              "no-caps": "",
                              size: "sm",
                              class: "text-caption text-grey-6 ml-breadcrumb-btn"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.currentPassage.pigRunName) + " ", 1),
                                _createVNode(_component_q_icon, {
                                  name: "arrow_drop_down",
                                  size: "16px",
                                  class: "q-ml-none"
                                }),
                                _createVNode(_component_q_menu, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_list, {
                                      dense: "",
                                      style: {"min-width":"150px"}
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pigRunOptions, (opt) => {
                                          return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                            key: opt.value,
                                            clickable: "",
                                            active: opt.value === _ctx.selectedPigRunId,
                                            onClick: ($event: any) => (_ctx.onSelectPigRun(opt.value))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_item_section, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(opt.label), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1032, ["active", "onClick"])), [
                                            [_directive_close_popup]
                                          ])
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_q_icon, {
                              name: "chevron_right",
                              size: "12px",
                              color: "grey-5"
                            }),
                            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-caption text-grey-5" }, "Marker", -1)),
                            _createVNode(_component_q_btn, {
                              flat: "",
                              dense: "",
                              "no-caps": "",
                              size: "sm",
                              class: "text-caption text-grey-9 text-bold ml-breadcrumb-btn"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.currentPassage.markerName) + " ", 1),
                                _createVNode(_component_q_icon, {
                                  name: "arrow_drop_down",
                                  size: "16px",
                                  class: "q-ml-none"
                                }),
                                _createVNode(_component_q_menu, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_list, {
                                      dense: "",
                                      style: {"min-width":"120px"}
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markerOptions, (opt) => {
                                          return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                            key: opt.value,
                                            clickable: "",
                                            active: 
                        opt.value === _ctx.currentPassage?.pipelineSectionMarkerId
                      ,
                                            onClick: ($event: any) => (_ctx.onSelectMarker(opt.value))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_item_section, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(opt.label), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1032, ["active", "onClick"])), [
                                            [_directive_close_popup]
                                          ])
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _createTextVNode(" Passage " + _toDisplayString(_ctx.currentIndex + 1) + " of " + _toDisplayString(_ctx.enrichedPassages.length) + " ", 1),
                            (_ctx.passagesAtCurrentMarker.total > 1)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _cache[9] || (_cache[9] = _createTextVNode(" — ", -1)),
                                  _createVNode(_component_q_btn, {
                                    flat: "",
                                    dense: "",
                                    round: "",
                                    icon: "chevron_left",
                                    size: "xs",
                                    color: "primary",
                                    disable: _ctx.prevPassageAtMarkerIndex === -1,
                                    onClick: _ctx.onPrevPassageAtMarker
                                  }, null, 8, ["disable", "onClick"]),
                                  _createTextVNode(" " + _toDisplayString(_ctx.passagesAtCurrentMarker.index) + "/" + _toDisplayString(_ctx.passagesAtCurrentMarker.total) + " at marker ", 1),
                                  _createVNode(_component_q_btn, {
                                    flat: "",
                                    dense: "",
                                    round: "",
                                    icon: "chevron_right",
                                    size: "xs",
                                    color: "primary",
                                    disable: _ctx.nextPassageAtMarkerIndex === -1,
                                    onClick: _ctx.onNextPassageAtMarker
                                  }, null, 8, ["disable", "onClick"])
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createVNode(_component_q_btn, {
                          flat: "",
                          dense: "",
                          round: "",
                          icon: "chevron_right",
                          color: "primary",
                          size: "sm",
                          disable: _ctx.nextMarkerFirstIndex === -1,
                          onClick: _ctx.onNextPassage
                        }, null, 8, ["disable", "onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-caption text-grey-6" }, "Time (UTC)", -1)),
                          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.formatTimestamp(_ctx.currentPassage.passageTimeStamp)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-caption text-grey-6" }, "UID", -1)),
                          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.currentPassage.uid ?? '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-caption text-grey-6" }, "ML", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mlWaveforms(_ctx.currentPassage), (wf) => {
                            return (_openBlock(), _createBlock(_component_q_badge, {
                              key: wf.passageWaveformId,
                              color: 
                _ctx.getMLColor(wf.mlPrediction ?? false, wf.mlConfidence ?? 0)
              
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.getMLConfidenceLabel(
                  wf.mlPrediction ?? false,
                  wf.mlConfidence ?? 0
                )) + " " + _toDisplayString(_ctx.getWaveformTypeLabel(wf.passageWaveformType)), 1)
                              ]),
                              _: 2
                            }, 1032, ["color"]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        (_ctx.waveformLoading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createVNode(_component_q_spinner, {
                                size: "24px",
                                color: "primary"
                              })
                            ]))
                          : (_ctx.decodedWaveforms.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, " No waveform data available "))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                (
                _ctx.canVerify &&
                !_ctx.isCurrentPassageVerified &&
                _ctx.decodedWaveforms.length > 1
              )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Click a waveform to select it, then press Verify "))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_24, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.decodedWaveforms, (wf) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: wf.passageWaveformId,
                                      class: _normalizeClass(["ml-waveform-card", {
                  'ml-waveform-selected':
                    _ctx.selectedWaveformId === wf.passageWaveformId,
                  'ml-waveform-selectable':
                    _ctx.canVerify && !_ctx.isCurrentPassageVerified,
                }]),
                                      onClick: ($event: any) => (
                  _ctx.canVerify &&
                    !_ctx.isCurrentPassageVerified &&
                    (_ctx.selectedWaveformId = wf.passageWaveformId)
                )
                                    }, [
                                      _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.getWaveformTypeLabel(wf.passageWaveformType)), 1),
                                      _createElementVNode("canvas", {
                                        ref_for: true,
                                        ref: 'mlCanvas_' + wf.passageWaveformId,
                                        width: "160",
                                        height: "90",
                                        class: "ml-waveform-canvas"
                                      }, null, 512)
                                    ], 10, _hoisted_25))
                                  }), 128))
                                ])
                              ], 64))
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_q_btn, {
                          unelevated: "",
                          dense: "",
                          color: "blue-grey-7",
                          icon: "skip_next",
                          label: "Last Verified",
                          class: "col",
                          style: {"font-size":"11px"},
                          disable: _ctx.goToLastVerifiedIndex === -1,
                          onClick: _ctx.onGoToLastVerified
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_tooltip, { "max-width": "220px" }, {
                              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                _createTextVNode(" Jump directly to the most recently verified passage ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disable", "onClick"]),
                        _createVNode(_component_q_btn, {
                          unelevated: "",
                          dense: "",
                          color: "blue-grey-7",
                          icon: "skip_next",
                          label: "Newest",
                          class: "col",
                          style: {"font-size":"11px"},
                          disable: _ctx.goToVerifyNextIndex === -1,
                          onClick: _ctx.onGoToVerifyNext
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_tooltip, { "max-width": "220px" }, {
                              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                _createTextVNode(" This will take you to the first marker that follows the marker with the last verified passage ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disable", "onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_q_btn, {
                          unelevated: "",
                          dense: "",
                          color: "primary",
                          icon: "my_location",
                          label: "Go to Marker",
                          class: "col",
                          style: {"font-size":"11px"},
                          onClick: _ctx.onGoToMarker
                        }, null, 8, ["onClick"]),
                        (_ctx.canVerify)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 0,
                              unelevated: "",
                              dense: "",
                              color: _ctx.isCurrentPassageVerified ? 'green' : 'orange',
                              icon: _ctx.isCurrentPassageVerified ? 'check_circle' : 'fact_check',
                              label: _ctx.isCurrentPassageVerified ? 'Unverify' : 'Verify Waveform',
                              class: "col",
                              style: {"font-size":"11px"},
                              onClick: _ctx.onVerify
                            }, null, 8, ["color", "icon", "label", "onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
        ]),
        _createVNode(_component_PipelineSectionMarkerPassagesDialog, { ref: "markerPassagesDialog" }, null, 512)
      ], 2))
    : _createCommentVNode("", true)
}